import { publicApi } from 'http'

export async function getCategories(params = {}) {
  // GET /api/categories/ - public request
  return publicApi.get('/categories/', { params })
}

export async function getProducts(params = {}) {
  // GET /api/products/?page=<n>&page_size=<m> - public
  return publicApi.get('/products/', { params })
}

export async function getProduct(id) {
  return publicApi.get(`/products/${id}/`)
}

export async function getProductImages(id) {
  return publicApi.get(`/products/${id}/images/`)
}

export async function getProductVariants(id) {
  return publicApi.get(`/products/${id}/variants/`)
}

export async function getSlides() {
  const res = await publicApi.get(`/slides/`)
  // return only the response data (array of slides)
  return res.data
}


export default { getCategories, getProducts, getProduct, getProductImages, getProductVariants }


